import React from 'react';
import { Container, Paper } from '@mui/material';
import styled from '@emotion/styled';
import AskAIConversation from '../components/AskAIConversation';

// The composer has to stay reachable without the page itself scrolling, so the shell claims the
// viewport below the navbar and lets the transcript be the only thing that scrolls.
const NAVBAR_HEIGHT = 64;

// Container fixes the width once, for the whole surface. Sizing anything inside it to its content
// is what made the page jump as answers arrived.
const PageContainer = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
}));

const Shell = styled(Paper)(() => ({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
}));

const Ask = () => (
    <PageContainer maxWidth="lg">
        <Shell elevation={1}>
            <AskAIConversation variant="page" />
        </Shell>
    </PageContainer>
);

export default Ask;
